module.exports = __webpack_public_path__ + "media/images/flags/gl-84ac5572fd0727fd850e09e4fc7a8b34.svg";